var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('my-power-station-one',{attrs:{"beg":_vm.beg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }